'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DashboardController = function () {
  function DashboardController(authService, userService, $scope, $interval) {
    "ngInject";

    (0, _classCallCheck3.default)(this, DashboardController);
    this.authService = authService;
    this.userService = userService;
    this.$scope = $scope;
    this.$interval = $interval;

    this.authService.getLocationExtendedProperties('dashboardPreferences');
    this.authService.getLocationExtendedProperties('gdprMaintenance');
    this.authService.getLocationExtendedProperties('webEnquiryManagerOnly');

    this.users = [{ userId: null, firstName: 'All Users' }];
    this.clonedUsers = null;
    this.selectedUser = this.users[0];
    this.selectedDate = new Date();
    this.currentPanel = null;

    this.dtPickerOptions = {
      minDate: new Date(),
      showButtonBar: false
    };

    this.stats = {
      promise: {
        statsLoaded: false,
        loaded: false,
        dueToday: 0,
        overdue: 0
      },
      webEnquiries: {
        loaded: false,
        count: 0
      },
      enquiries: {
        loaded: false,
        count: 0
      },
      finances: {
        loaded: false,
        count: 0
      },
      deliveries: {
        loaded: false,
        dueToday: 0,
        overdue: 0
      },
      recentContacts: {
        loaded: false
      },
      contactMatches: {
        loaded: false,
        count: 0
      },
      vehicleMatches: {
        loaded: false,
        count: 0
      },
      expiringContacts: {
        loaded: false,
        count: 0
      }
    };

    if (this.authService.isManager()) {
      this.loadUsers();
    } else {
      this.$interval(this.reloadDashboard.bind(this), 1, 1);
    }
  }

  (0, _createClass3.default)(DashboardController, [{
    key: 'loadUsers',
    value: function loadUsers() {
      var ctrl = this;

      ctrl.userService.getLocationUsers(ctrl.authService.authData.currentLocation.key, true).then(function (response) {
        ctrl.users = [ctrl.users[0]].concat((0, _toConsumableArray3.default)(response.data));

        /*
        * Set the Current User as Selected User as per the User Preference
        * or All Users
        * Take in account a rare edge case scenario, when a User has marked
        * DashboardDefaultMyUser and DashboardHidden both true in User Preferences
        */
        if (ctrl.authService.authData.currentLocation.dashboardDefaultMyUser) {
          var currentUser = (0, _lodash.find)(ctrl.users, function (o) {
            return o.userId === ctrl.authService.authData.userId;
          });
          ctrl.selectedUser = currentUser || ctrl.users[0];
        }

        //Cloning a Copy of Location users to be reused for Web Enquiries
        ctrl.clonedUsers = (0, _lodash.clone)(ctrl.users);

        ctrl.reloadDashboard();
      });
    }
  }, {
    key: 'reloadDashboard',
    value: function reloadDashboard() {
      this.viewPromisesStats();
      this.viewOpenEnquiriesStats();
      this.viewOpenFinancesStats();
      this.viewPendingDeliveriesStats();
      this.viewContactMatches();
      this.viewVehicleMatches();
      this.viewWebEnquiriesStats();
      this.viewExpiringContactsStats();

      this.reloadOpenPanel();
    }

    //#region Promises

  }, {
    key: 'viewPromisesStats',
    value: function viewPromisesStats() {
      if (this.hasPanelVisibility('promises')) {
        this.stats.promise.loaded = false;
        this.$scope.$broadcast('dashboard:promisesStats', { userId: this.selectedUser.userId, selectedDate: this.selectedDate });
      }
    }
  }, {
    key: 'viewPromises',
    value: function viewPromises(reload) {
      if (this.hasPanelVisibility('promises')) {
        this.currentPanel = 'promises';
        this.stats.promise.loaded = false;
        this.$scope.$broadcast('dashboard:promises', { reload: reload });
      }
    }
  }, {
    key: 'promisesLoaded',
    value: function promisesLoaded(dueToday, overdue) {
      this.stats.promise.statsLoaded = true;
      this.stats.promise.dueToday = dueToday;
      this.stats.promise.overdue = overdue;
    }

    //#endregion

    //#region Web Enquiries

  }, {
    key: 'viewWebEnquiriesStats',
    value: function viewWebEnquiriesStats() {
      if (this.hasPanelVisibility('webEnquiries')) {
        this.stats.webEnquiries.loaded = false;
        this.$scope.$broadcast('dashboard:viewWebEnquiriesStats', null);
      }
    }
  }, {
    key: 'viewWebEnquiries',
    value: function viewWebEnquiries(reload) {
      if (this.hasPanelVisibility('webEnquiries')) {
        this.currentPanel = 'webEnquiries';;
        this.stats.webEnquiries.loaded = false;
        this.$scope.$broadcast('dashboard:viewWebEnquiries');
      }
    }
  }, {
    key: 'webEnquiriesLoaded',
    value: function webEnquiriesLoaded(count) {
      this.stats.webEnquiries.statsLoaded = true;
      this.stats.webEnquiries.count = count;
    }

    //#endregion

    //#region Recent Contacts

  }, {
    key: 'viewRecentContacts',
    value: function viewRecentContacts() {
      if (this.hasPanelVisibility('top10RecentContacts')) {
        this.currentPanel = 'top10RecentContacts';
        this.stats.recentContacts.loaded = false;
        this.$scope.$broadcast('dashboard:viewContacts', { userId: this.selectedUser.userId });
      }
    }
  }, {
    key: 'recentContactsLoaded',
    value: function recentContactsLoaded() {
      this.stats.recentContacts.loaded = true;
    }

    //#endregion

    //#region Open Enquiries

  }, {
    key: 'viewOpenEnquiriesStats',
    value: function viewOpenEnquiriesStats() {
      if (this.hasPanelVisibility('openEnquiries')) {
        this.stats.enquiries.loaded = false;
        this.$scope.$broadcast('dashboard:viewOpenEnquiriesStats', { userId: this.selectedUser.userId });
      }
    }
  }, {
    key: 'viewOpenEnquiries',
    value: function viewOpenEnquiries(reload) {
      if (this.hasPanelVisibility('openEnquiries')) {
        this.currentPanel = 'openEnquiries';
        this.stats.enquiries.loaded = false;
        this.$scope.$broadcast('dashboard:viewOpenEnquiries', { reload: reload });
      }
    }
  }, {
    key: 'enquiriesLoaded',
    value: function enquiriesLoaded(count) {
      this.stats.enquiries.statsLoaded = true;
      this.stats.enquiries.count = count;
    }

    //#endregion

    //#region Open Finances

  }, {
    key: 'viewOpenFinancesStats',
    value: function viewOpenFinancesStats() {
      if (this.hasPanelVisibility('openFinances')) {
        this.stats.finances.loaded = false;
        this.$scope.$broadcast('dashboard:viewOpenFinancesStats', { userId: this.selectedUser.userId });
      }
    }
  }, {
    key: 'viewOpenFinances',
    value: function viewOpenFinances(reload) {
      if (this.hasPanelVisibility('openFinances')) {
        this.currentPanel = 'openFinances';
        this.stats.finances.loaded = false;
        this.$scope.$broadcast('dashboard:viewOpenFinances', { reload: reload });
      }
    }
  }, {
    key: 'financesLoaded',
    value: function financesLoaded(count) {
      this.stats.finances.statsLoaded = true;
      this.stats.finances.count = count;
    }

    //#endregion

    //#region Pending Deliveries

  }, {
    key: 'viewPendingDeliveriesStats',
    value: function viewPendingDeliveriesStats() {
      if (this.hasPanelVisibility('pendingDeliveries')) {
        this.stats.deliveries.loaded = false;
        this.$scope.$broadcast('dashboard:viewPendingDeliveriesStats', { userId: this.selectedUser.userId, selectedDate: this.selectedDate });
      }
    }
  }, {
    key: 'viewPendingDeliveries',
    value: function viewPendingDeliveries(reload) {
      if (this.hasPanelVisibility('pendingDeliveries')) {
        this.currentPanel = 'pendingDeliveries';
        this.stats.deliveries.loaded = false;
        this.$scope.$broadcast('dashboard:viewPendingDeliveries', { reload: reload });
      }
    }
  }, {
    key: 'deliveriesLoaded',
    value: function deliveriesLoaded(dueToday, overdue) {
      this.stats.deliveries.statsLoaded = true;
      this.stats.deliveries.dueToday = dueToday;
      this.stats.deliveries.overdue = overdue;
    }

    //#endregion

    //#region Contact Matches

  }, {
    key: 'viewContactMatches',
    value: function viewContactMatches() {
      if (this.hasPanelVisibility('matchingContacts')) {
        this.stats.contactMatches.loaded = false;
        this.$scope.$broadcast('dashboard:viewContactMatches', { userId: this.selectedUser.userId });
      }
    }
  }, {
    key: 'contactMatchesLoaded',
    value: function contactMatchesLoaded(count) {
      this.stats.contactMatches.loaded = true;
      this.stats.contactMatches.count = count;
    }

    //#endregion

    //#region Vehicle Matches

  }, {
    key: 'viewVehicleMatches',
    value: function viewVehicleMatches() {
      if (this.hasPanelVisibility('matchingVehicles')) {
        this.stats.vehicleMatches.loaded = false;
        this.$scope.$broadcast('dashboard:viewVehicleMatches', { userId: this.selectedUser.userId });
      }
    }
  }, {
    key: 'vehicleMatchesLoaded',
    value: function vehicleMatchesLoaded(count) {
      this.stats.vehicleMatches.loaded = true;
      this.stats.vehicleMatches.count = count;
    }

    //#endregion

    //#region Expiring Contacts

  }, {
    key: 'viewExpiringContactsStats',
    value: function viewExpiringContactsStats() {
      if (this.hasExpiringContatsPanelVisibility()) {
        this.stats.expiringContacts.loaded = false;
        this.$scope.$broadcast('dashboard:viewExpiringContactsStats', { userId: this.selectedUser.userId });
      }
    }
  }, {
    key: 'viewExpiringContacts',
    value: function viewExpiringContacts(reload) {
      if (this.hasExpiringContatsPanelVisibility()) {
        this.currentPanel = 'expiringContacts';
        this.stats.expiringContacts.loaded = false;
        this.$scope.$broadcast('dashboard:viewExpiringContacts', { reload: reload });
      }
    }
  }, {
    key: 'expiringContactsLoaded',
    value: function expiringContactsLoaded(count) {
      this.stats.expiringContacts.statsLoaded = true;
      this.stats.expiringContacts.count = count;
    }

    //#endregion

  }, {
    key: 'hasPanelVisibility',
    value: function hasPanelVisibility(panelName) {
      return true;
      //return this.authService.authData.currentLocation.dashboardPreferences.panelVisibility != null && this.authService.authData.currentLocation.dashboardPreferences.panelVisibility[panelName];
    }
  }, {
    key: 'hasExpiringContatsPanelVisibility',
    value: function hasExpiringContatsPanelVisibility() {
      return true;
      //return this.authService.authData.currentLocation.gdprMaintenance != null && this.authService.authData.currentLocation.gdprMaintenance.enabled;
    }
  }, {
    key: 'reloadOpenPanel',
    value: function reloadOpenPanel() {
      if (!this.currentPanel) {
        return;
      }

      if (this.currentPanel === 'promises') {
        this.viewPromises(true);
      } else if (this.currentPanel === 'openEnquiries') {
        this.viewOpenEnquiries(true);
      } else if (this.currentPanel === 'openFinances') {
        this.viewOpenFinances(true);
      } else if (this.currentPanel === 'pendingDeliveries') {
        this.viewPendingDeliveries(true);
      } else if (this.currentPanel === 'webEnquiries') {
        this.viewWebEnquiries(true);
      } else if (this.currentPanel === 'expiringContacts') {
        this.viewExpiringContacts(true);
      }
    }
  }]);
  return DashboardController;
}();

exports.default = DashboardController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/dashboard.controller.js